import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Container, Paper, Snackbar, Alert } from '@mui/material';
import TripForm from './components/TripForm';
import TripResult from './components/TripResult';
import openaiService from './services/openaiService';
import weatherService from './services/weatherService';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32',
    },
    secondary: {
      main: '#90CAF9',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25,
          textTransform: 'none',
          padding: '10px 20px',
        },
      },
    },
  },
});

function App() {
  const [tripData, setTripData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePlanTrip = async (formData) => {
    setLoading(true);
    setError(null);
    
    try {
      // Initialize trip data with loading states
      setTripData({
        dates: {
          start: formData.fromDate,
          end: formData.toDate,
        },
        route: `${formData.flyingFrom} → ${formData.flyingTo}`,
        weather: "Loading weather data...",
        flights: "Searching for the best flights...",
        hotel: "Finding the perfect accommodation..."
      });

      // Get weather data
      const weatherData = await weatherService.getWeatherForecast(
        formData.flyingTo,
        formData.fromDate
      );

      // Get trip recommendations
      const recommendations = await openaiService.getTripRecommendations(formData);

      // Update trip data with real data
      setTripData(prev => ({
        ...prev,
        weather: weatherData,
        flights: recommendations.flights,
        hotel: recommendations.hotel
      }));
    } catch (err) {
      console.error('Error planning trip:', err);
      setError('Failed to plan trip. Please try again.');
      setTripData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            borderRadius: 4,
            overflow: 'hidden',
            minHeight: '80vh'
          }}
        >
          {!tripData ? (
            <TripForm onSubmit={handlePlanTrip} disabled={loading} />
          ) : (
            <TripResult tripData={tripData} loading={loading} />
          )}
        </Paper>
        <Snackbar 
          open={!!error} 
          autoHideDuration={6000} 
          onClose={() => setError(null)}
        >
          <Alert severity="error" onClose={() => setError(null)}>
            {error}
          </Alert>
        </Snackbar>
      </Container>
    </ThemeProvider>
  );
}

export default App;
